import { __exports as e } from "./index153.js";
var n;
function i() {
  if (n) return e;
  n = 1;
  var t = /\d{13}/;
  return e.is = function(r) {
    return t.test(r);
  }, e.parse = function(r) {
    return r = parseInt(r, 10), new Date(r);
  }, e;
}
export {
  i as __require
};
//# sourceMappingURL=index134.js.map
